const videoRation = ($video) => {
    const $videoIframe = $video.find('iframe');
    const videoEl = $videoIframe[0];

    let videoBgWidth = $video.outerWidth();
    let videoBgHeight = $video.outerHeight();

    let videoW = videoEl.width;
    let videoH = videoEl.height;
    let videoRatio = ( videoW / videoH ).toFixed(2);

    let widthRatio = (videoBgWidth / videoW).toFixed(2);
    let heightRatio = (videoBgHeight / videoH).toFixed(2);

    let newWidth = widthRatio > heightRatio ? videoBgWidth : Math.ceil( videoBgHeight * videoRatio );
    let newHeight = widthRatio > heightRatio ? Math.ceil( videoBgWidth / videoRatio ) : videoBgHeight;

    $videoIframe.css({
        'width': newWidth,
        'height': newHeight
    });
}

export default videoRation;
